export default "__VITE_ASSET__BPzZDjOk__"